export const AuthBackground = ({ children }: React.PropsWithChildren) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white ">{children}</div>
  );
};
